module.exports = __webpack_public_path__ + "1721f8f9a3e62f9892897d3d70e4f64b.png";